import React from "react";
import { useTranslation } from "react-i18next";

type LegendProps = {
    showPromo?: boolean;
    showCheaper?: boolean;
};

const Legend: React.FC<LegendProps> = ({ showPromo, showCheaper }) => {
    const { t } = useTranslation();

    const Item: React.FC<{ sample: React.ReactNode; label: string }> = ({ sample, label }) => (
        <div className="flex items-center gap-2 mr-4 mb-2 text-xs">
            <div className="shrink-0">{sample}</div>
            <span className="opacity-80">{label}</span>
        </div>
    );

    return (
        <div className="mt-3 px-1 flex flex-wrap">
            <Item
                sample={<div className="text-gray-500 line-through">15</div>}
                label={t("calendar.legend.unavailable", { defaultValue: "Date unavailable" })}
            />
            {showPromo && (
                <Item
                    sample={
                        <span className="inline-flex items-center justify-center rounded-full px-2 py-0.5 text-[10px] font-semibold bg-emerald-100 text-emerald-700">
                            15
                        </span>
                    }
                    label={t("calendar.legend.cheaper", { defaultValue: "Special offer" })}
                />
            )}
            {showCheaper && (
                <Item
                    sample={
                        <span className="inline-flex items-center justify-center rounded-full px-2 py-0.5 text-[10px] font-semibold bg-[#f9a82536]">
                            15
                        </span>
                    }
                    label={t("calendar.legend.cheaper", { defaultValue: "Cheaper date" })}
                />
            )}
        </div>
    );
};

export default Legend;